import fetch from "./http";
import {
  userInfo,
  collectCrystal,
  myFirstPet,
  sendGuideState,
  guideStatus,
} from "./user";
import {
  monsterList,
  defaultMonster,
  buyMonster,
  feed,
  rename,
  selectedPetList,
} from "./monster";
import { taskList, getTask } from "./task";
import {
  battleInit,
  matchingOp,
  startBattle,
  setTeam,
  rankList,
  abandonFight,
  dayReword,
  seasonReword,
} from "./battle";
import {
  villageInfo,
  villageGameModeInfo,
  villagePvpOpponentList,
  villageStartGame,
  villageToPrize,
  villageRankList,
  villageStoreList,
  villageExchange,
  villageRankReward,
} from "./village";

// 多语言
export function fetchLang(lang_id) {
  return fetch({
    url: "//ucms-api.youzu.com/api/source/message",
    params: {
      site_id: 1124,
      lang_id,
    },
  });
}
export default {
  fetchLang,
  userInfo,
  collectCrystal,
  myFirstPet,
  sendGuideState,
  guideStatus,
  monsterList,
  defaultMonster,
  buyMonster,
  feed,
  rename,
  selectedPetList,
  taskList,
  getTask,
  battleInit,
  matchingOp,
  startBattle,
  setTeam,
  rankList,
  abandonFight,
  dayReword,
  seasonReword,
  villageInfo,
  villageGameModeInfo,
  villagePvpOpponentList,
  villageStartGame,
  villageToPrize,
  villageRankList,
  villageStoreList,
  villageExchange,
  villageRankReward,
};
